export const API_BASE = process.env.NODE_ENV === 'DEV' ? 'ws://localhost:3004/' : 'wss://lista.ba:8443/';
export const STORAGE_API = process.env.NODE_ENV === 'DEV' ? 'http://localhost:3004' : 'https://lista.ba:8443';
export const FRONTEND_URL = process.env.NODE_ENV === 'DEV' ? 'http://localhost:3001' : 'https://lista.ba:8443';

export const SMALL_IMAGE = STORAGE_API + '/images/144x105/';
export const MEDIUM_IMAGE = STORAGE_API + '/images/365x205/';
export const LARGE_IMAGE = STORAGE_API + '/images/1110x630/';
// 192.168.134.203
